import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon, ClipboardListIcon, TruckIcon, SparklesIcon, HelpCircleIcon } from 'lucide-react';
import { PageHero } from '../components/PageHero';
import { SectionHeading } from '../components/SectionHeading';
import { CTABand } from '../components/CTABand';
import { STEPS } from '../lib/content';
const STEP_ICONS = [PhoneIcon, ClipboardListIcon, TruckIcon, SparklesIcon];
const FAQ = [{
  q: 'How fast can you come out?',
  a: 'Most jobs get same-day or next-day service. Call in the morning and we\'ll do our best to have it hauled by the afternoon.'
}, {
  q: 'Do I have to move anything first?',
  a: 'Nope. Point at it and we handle the rest — from the basement, attic, or third floor. You never lift a thing.'
}, {
  q: 'How do you price a job?',
  a: 'Pricing is based on how much space your junk takes up in the trailer. We give you the exact price before we start — no surprises.'
}, {
  q: 'What happens to my stuff?',
  a: 'We sort everything. Usable items get donated, recyclables get recycled, and only true trash goes to the dump.'
}, {
  q: 'What can\'t you take?',
  a: 'We can\'t haul hazardous materials like wet paint, chemicals, or asbestos. Ask us and we\'ll point you the right way.'
}];
export function HowItWorks() {
  return <>
      <PageHero eyebrow="How It Works" title={<>Simple as <span className="text-jk-red" data-id="element-234" data-mp="1dyfensfyvaaa">1-2-3-4</span></>} subtitle="No haggling, no hassle. Here's exactly what happens from the moment you call." data-id="element-233" data-mp="1e11ojyqby1vo" />

      <section className="bg-jk-ink py-20" data-id="element-235" data-mp="140iwwhsixh37">
        <div className="mx-auto max-w-7xl px-4 sm:px-6" data-id="element-236" data-mp="100h7b702ce4a">
          <div className="relative grid gap-6 lg:grid-cols-4" data-id="element-237" data-mp="1010m4euf2me3">
            {STEPS.map((step, i) => {
            const Icon = STEP_ICONS[i];
            return <motion.div key={step.n} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} className="relative rounded-2xl border border-white/10 bg-jk-panel p-7" data-id="element-238" data-mp="2uervrecqx69j" data-mpi={i}>
                  <div className="flex items-center justify-between" data-id="element-239" data-mp="2zjc5o2xywlv5">
                    <span className="inline-flex h-12 w-12 items-center justify-center rounded-lg bg-jk-red text-white" data-id="element-240" data-mp="2zl6p1ctlc5x4">
                      <Icon className="h-6 w-6" data-id="element-241" data-mp="34g2mishljlhm" />
                    </span>
                    <span className="font-display text-5xl font-extrabold text-white/10" data-id="element-242" data-mp="3s8srghr314ie">{step.n}</span>
                  </div>
                  <h3 className="mt-4 font-display text-2xl font-bold uppercase text-white" data-id="element-243" data-mp="3i9tvnzrf13ct">{step.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-white/60" data-id="element-244" data-mp="3n8oakqm9i7rn">{step.text}</p>
                </motion.div>;
          })}
          </div>
        </div>
      </section>

      <section className="bg-white py-20" data-id="element-245" data-mp="2btrljgq2vika">
        <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-246" data-mp="2bukijpz8itp8">
          <SectionHeading light eyebrow="FAQ" title={<>Questions? <span className="text-jk-red" data-id="element-248" data-mp="248p361jhknk2">Answered.</span></>} data-id="element-247" data-mp="24a8lrysm7ap0" />
          <div className="mt-10 space-y-4" data-id="element-249" data-mp="1zboz1w675uvl">
            {FAQ.map((item, i) => <motion.div key={item.q} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} className="rounded-xl border border-black/10 bg-neutral-50 p-6" data-id="element-250" data-mp="2daolcx68lxol" data-mpi={i}>
                <h3 className="flex items-start gap-2 font-display text-xl font-bold uppercase text-jk-ink" data-id="element-251" data-mp="1glyzywveimxv">
                  <HelpCircleIcon className="mt-0.5 h-5 w-5 flex-shrink-0 text-jk-red" data-id="element-252" data-mp="1udnc305nhbeu" /> {item.q}
                </h3>
                <p className="mt-2 pl-7 text-black/60" data-id="element-253" data-mp="1pj9ecr3ims70">{item.a}</p>
              </motion.div>)}
          </div>
        </div>
      </section>

      <CTABand data-id="element-254" data-mp="wxggmvx2u3r3" />
    </>;
}